import React, { useState } from 'react'
import { data } from '../Constant/data';
import Button from '../Common/Button/Button'
import MobilePreview from '../Common/MobilePreview/MobilePreview'
import CustomPopup from '../Common/CustomPopup/CustomPopup'
import { bannerCreationPopup } from '../Constant/bannerCreation'
import close from '../../../../assets/images/ads/close_button.svg'
import ImageCropper from '../Imagecropper/ImageCropper'
import ArrowNavigation from '../../../../assets/images/ads/arrow.png'

const TryCreative = () => {
    const [selectedImage, setSelectedImage] = useState(null)
    const [imageName, setImageName] = useState('');
    const [adBannerPopup, setAdBannerPopup] = useState(false);
    const [cropperError, setCropperError] = useState();
    const bannerPopupData = bannerCreationPopup;
    let tryCreative = data?.tryCreative
    const [loading , setLoading] = useState(false)
    // Handle image selection
    const handleImageChange = (e) => {
        const file = e.target.files[0]
        if (file) {
            setSelectedImage(URL.createObjectURL(file))
            setImageName(file.name) // Set the name of the selected image
        }
    }


    // Trigger the file input click event
    const handleButtonClick = async () => {
        if (selectedImage) {
            setLoading(true); // Start loading
            try {
                const formData = new FormData();
                formData.append('image', document.getElementById('imageInput').files[0]); // Append the selected image file

                const response = await fetch('https://your-api-endpoint.com/upload', {
                    method: 'POST',
                    body: formData,
                });

                if (!response.ok) {
                    throw new Error('Failed to upload image');
                }

                const result = await response.json();
                console.log('Image uploaded successfully:', result);

                // Optionally update the selectedImage with the URL returned from the API
                setSelectedImage(result.imageUrl);
            } catch (error) {
                console.error('Error uploading image:', error);
                alert('Failed to upload image. Please try again.');
            } finally {
                setLoading(false); // End loading
            }
        } else {
            document.getElementById('imageInput').click(); // Trigger file input
        }
    };

    const handleCancel = () => {
        setAdBannerPopup(false)
    }
    const handleCroppedImage = (dataUrl) => {
        setSelectedImage(dataUrl)
    };


    return (
        <section className='upload_banner' id={tryCreative?.id}>
            <figure className="bg_img cover">
                <img src={tryCreative?.bg_image?.url} alt={tryCreative?.bg_image?.alt} />
            </figure>
            <div className="container">
                <div className="cnt">
                    <h2 className='text_xxl mb'>Try Your <span className='text_white'>Creative</span> Now!</h2>
                    <p className='text_md2'>{tryCreative?.description}</p>
                    <div className="button_wrap mt">
                        <Button
                            label={tryCreative?.ctaText}
                            className={`btn ${selectedImage && 'upload'}`}
                            type="secondary"
                            onClick={handleButtonClick} // Trigger file input on button click
                        />
                        <ImageCropper onCrop={handleCroppedImage} onClose={() => console.log("Popup closed")} />
                        {/* <input
                            type="file"
                            id="imageInput"
                            accept="image/*"
                            onChange={handleImageChange}
                            style={{ opacity: '0', zIndex: '9999', cursor: 'pointer' }}
                        /> */}
                    </div>
                    {/* {selectedImage && (
                        <div className="image-preview">
                            <img src={selectedImage} alt="Selected" className="selected-image" />
                            <span className='selected-image-text'>{imageName}</span>
                        </div>
                    )} */}
                    <span className='block text_sm2'>{tryCreative?.ctaNote}</span>
                    <div className="ad_banner_help text_red">
                        <a className=" text-center text_sm md text_white fw_500 underline" onClick={() => {
                            setAdBannerPopup(true)
                        }}>Need help creating the perfect ad ?</a>
                    </div>
                </div>
                <div className="preview_wrap">
                    <MobilePreview poster={selectedImage} />
                </div>
                {
                    adBannerPopup && (
                        <CustomPopup className='banner_creation_popup'>
                            <div className="cnt">
                                <div className="close_btn_wrapper">
                                    <button className='close_button' onClick={handleCancel}><img src={close} alt="" /></button>
                                </div>
                                <div className="top">
                                    <div className="banner">
                                        <figure className="bg"><img src={bannerPopupData?.company_info?.banner_bg} alt="" /></figure>
                                        <figure className="cnt center">
                                            <img src={bannerPopupData?.company_info?.digital_cnt} alt="" />
                                        </figure>
                                        <div className="social_visit_wrap">
                                            <ul className="social_icons">
                                                {
                                                    bannerPopupData.social_media_icons.map((el, index) => {
                                                        return (
                                                            <li key={index}>
                                                                <a href={el.url} target="_blank" rel="noopener noreferrer" alt={el.platform}>
                                                                    <img src={el.icon} alt={el.platform} /> {/* Use el.platform as alt */}
                                                                </a>
                                                            </li>
                                                        );
                                                    })
                                                }
                                            </ul>
                                            <div className="visit_block">
                                                <span className="text_xsm">Visit our website</span>
                                                <a href="https://fliptreedigital.com/" className="text_xsm text_blue">www.fliptreedigital.com</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="bottom">
                                    <div className="cnt">
                                        <p className='text_md2'>At <strong>FlipTree Digital</strong>, We are a full-scale advertising agency with an in-house media, graphic, and production studio. We provide the creative fuel to help clients across the globe take their business to the next level.Specializing in digital marketing, brand building, social media, creatives, and marketing strategy. Let us manage your brand while you focus on growing your business. </p>
                                        <div className="offers_block">
                                            <span className='bg_red text_md2' >{bannerPopupData?.company_info?.special_offer}</span>
                                            <ul>
                                                <li className='text_red'>
                                                    <span className='text_md2'>{bannerPopupData?.company_info?.contact?.phone?.title}</span>
                                                    <a href={`tel:${bannerPopupData?.company_info?.contact?.phone?.number}`} className='text_md2'>
                                                        {bannerPopupData?.company_info?.contact?.phone?.formatted}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href={`mailto:${bannerPopupData?.company_info?.contact?.email?.mail}`} className='text_md2'>
                                                        <span>{bannerPopupData?.company_info?.contact?.email?.title}</span>
                                                        {bannerPopupData?.company_info?.contact?.email?.mail}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </CustomPopup>
                    )
                }

            </div>
        </section>
    )
}

export default TryCreative
